<template>
	<div class="page">
		<HeaderBar title="化验检查"></HeaderBar>
		<div class="center-box-no-footer">
			<van-form :model="form" ref="form">
				<van-cell-group title="丙肝病毒学">
					<van-row>
						<van-col span="18">
							<FormNormalInput label="HCV RNA" v-model="form.bq418.Bq418_002" required />
						</van-col>
						<van-col span="6" class="unit">IU/mL</van-col>
					</van-row>
					<van-row v-show="bq400.Bq400_999 == 0">
						<van-col span="18">
							<StaticSingleSelect label="HCV基因型" :selectkey.sync="form.bq418.Bq418_003"
								:list="booleanList" :required="isrequired" />
						</van-col>
						<van-col span="6" class="unit">型</van-col>
					</van-row>
				</van-cell-group>
				<van-cell-group title="血常规">
					<van-row>
						<van-col span="18">
							<FormNormalInput label="WBC" v-model="form.bq418.Bq418_005" />
						</van-col>
						<van-col span="6" class="unit">×10^9/L</van-col>
					</van-row>
					<van-row>
						<van-col span="18">
							<FormNormalInput label="PLT" v-model="form.bq418.Bq418_006" />
						</van-col>
						<van-col span="6" class="unit">×10^9/L</van-col>
					</van-row>
				</van-cell-group>
				<van-cell-group title="生化">
					<van-row>
						<van-col span="18">
							<FormNormalInput label="ALT" v-model="form.bq418.Bq418_007" />
						</van-col>
						<van-col span="6" class="unit">U/L</van-col>
					</van-row>
					<van-row>
						<van-col span="18">
							<FormNormalInput label="AST" v-model="form.bq418.Bq418_008" />
						</van-col>
						<van-col span="6" class="unit">U/L</van-col>
					</van-row>
					<van-row>
						<van-col span="18">
							<FormNormalInput label="CRE" v-model="form.bq418.Bq418_009" />
						</van-col>
						<van-col span="6" class="unit">umol/L</van-col>
					</van-row>
					<van-row>
						<van-col span="15">
							<FormNormalInput label="eGFR" v-model="form.bq418.Bq418_010" />
						</van-col>
						<van-col span="9" class="unit">mL/(min·1.73m^2)</van-col>
					</van-row>
					<van-row>
						<van-col span="18">
							<FormNormalInput label="TCHO" v-model="form.bq418.Bq418_011" />
						</van-col>
						<van-col span="6" class="unit">umol/L</van-col>
					</van-row>
					<van-row>
						<van-col span="18">
							<FormNormalInput label="TG" v-model="form.bq418.Bq418_012" />
						</van-col>
						<van-col span="6" class="unit">umol/L</van-col>
					</van-row>
					<van-row>
						<van-col span="18">
							<FormNormalInput label="UA" v-model="form.bq418.Bq418_013" />
						</van-col>
						<van-col span="6" class="unit">umol/L</van-col>
					</van-row>
				</van-cell-group>
				<van-cell-group title="Child-Pugh评分（肝硬化患者）">
					<van-row>
						<van-col span="18">
							<FormNormalInput label="Child-Pugh" v-model="form.bq418.Bq418_014" />
						</van-col>
						<van-col span="6" class="unit">分</van-col>
					</van-row>
				</van-cell-group>
				<van-cell-group title="乙肝病毒学（合并HBV感染者）">
					<van-row>
						<van-col span="18">
							<FormNormalInput label="HBV DNA" v-model="form.bq418.Bq418_015" />
						</van-col>
						<van-col span="6" class="unit">IU/ml</van-col>
					</van-row>
				</van-cell-group>
				<FormNormalUpload label="查看报告" ref="normalUpload" :infoGuid='form.bq418.guid'>
				</FormNormalUpload>
				<div class="page-bottom-box" style="margin: 16px;" v-show='!savestate && bq400.Bq400_996 == "0"'>
					<SaveButton :url="saveUrl" ref="btnSave" back="0" @saveSucess="saveSucess"
						:editMode="form.bq418.guid != ''" class="hide">保存
					</SaveButton>
					<van-button block type="info" @click="SaveInfo">保存</van-button>
				</div>
				<div class="page-bottom-box" style="margin: 16px;" v-show='savestate'>
					<van-button block type="info">提交中……</van-button>
				</div>
			</van-form>
		</div>
	</div>
</template>

<script>
// 引入服务组件
import componentsModel from '../../../base/components.js'
// 引入子页面的混入对象
import mixinModel from '../mixins/mixins.js'
export default {
	name: "page012",
	mixins: [mixinModel],
	data() {
		return {
			modelname: 'bq418',
			form: {
				bq418: {
					id: "0", //编号
					guid: "", //guid编号
					companyGuid: "", //单位编号
					departmentGuid: "", //部门编号
					checkStatus: "", //审核状态
					dataStatus: "", //数据状态
					addUid: "", //添加人编号
					addTime: "", //添加时间					
					Bq400_guid: '', //随访基本信息表编号
					Bq418_002: '', //HCV RNA定量
					Bq418_003: '', //HCV基因型
					Bq418_004: '', //不详
					Bq418_005: '', //WBC
					Bq418_006: '', //PLT
					Bq418_007: '', //ALT
					Bq418_008: '', //AST
					Bq418_009: '', //CRE
					Bq418_010: '', //eGFR
					Bq418_011: '', //TCHO
					Bq418_012: '', //TG
					Bq418_013: '', //UA
					Bq418_014: '', //Child-Pugh
					Bq418_015: '', //HBV DNA定量
				},
				sempFiles: []
			},
			fullscreenLoading: false,
			//保存接口
			saveUrl: this.$utils.Url.s400 + '/api/S400Bq418/Save',
			dataList: [],
			bq400: JSON.parse(sessionStorage.getItem('bq400')),
			savestate: false,
			isrequired: false,
			//1a，1b，2a，3a，3b，6a，6b,不详
			booleanList: [{ id: '1a', name: '1a' }, { id: '1b', name: '1b' }, { id: '2a', name: '2a' }, { id: '3a', name: '3a' }, { id: '3b', name: '3b' }, { id: '6a', name: '6a' }, { id: '6b', name: '6b' }, { id: '不详', name: '不详' }]
		}
	},
	components: {
		...componentsModel
	},
	methods: {
		//加载信息
		LoadInfo: function () {
			var that = this
			var args = {
				bq400guid: this.bq400.guid
			}
			that.$utils.HttpPost(this.$utils.Url.s400 + '/api/S400Bq418/Info', args, function (d) {
				let dataModel = d.Data
				if (dataModel != null) {
					that.$utils.CopyKeyInfo(dataModel, dataModel)
					that.$set(that.form, "bq418", dataModel)
				}
			}, null, null, null);
		},

		//保存信息
		SaveInfo: function () {
			let that = this
			that.form.sempFiles = that.$refs.normalUpload.GetFileList()
			that.$refs.btnSave.Save()
		},
	},
	mounted() {
		this.form.bq418.Bq400_guid = this.bq400.guid
		this.isrequired = this.bq400.Bq400_999 == 0
		this.LoadInfo()
	}
}
</script>

<style scoped>
.unit {
	padding-top: 0.5rem;
	color: #999;
	font-size: 0.9em;
}
</style>
